import { User, UserState } from '@/interface/user-role.interface';
import { ROLE_PERMISSIONS, ROLES } from '@/services/roles';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: UserState = {
  profile: null,
  currentRole: ROLES.ADMIN,
  permissions: ROLE_PERMISSIONS[ROLES.ADMIN] || [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.profile = action.payload;
      // Aggregating all permissions from roles
      // In a real app, this might come pre-calculated from backend or calculated here
      // state.permissions = action.payload.permissions; 
    },
    setPermissions(state, action: PayloadAction<string[]>) {
      state.permissions = action.payload;
    },
    // Keep for backward compatibility if needed, or remove if fully migrating
    setRole(state, action: PayloadAction<string>) {
      state.currentRole = action.payload;
      state.permissions = ROLE_PERMISSIONS[action.payload] || [];
    },
  },
});

export const { setUser, setPermissions, setRole } = userSlice.actions;
export default userSlice.reducer;
// Selectors
export const selectUserPermissions = (state: { user: UserState }) => state.user.permissions;
export const selectUserProfile = (state: { user: UserState }) => state.user.profile;
